module.exports = __webpack_public_path__ + "img/i-tip.cc14da0a.png";